import React from 'react';
import { CheckIcon, CreditCardIcon, MailCheckIcon, UsersIcon } from 'lucide-react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
const INCLUDED = ['Libro principal Diccionario Apple completo', '5 bonos estratégicos de regalo', '6 módulos: ajustes, batería, trucos, herramientas, cámara y seguridad', 'Paga con Mercado Pago de forma segura', 'Acceso inmediato vía mail', 'Acceso a mi comunidad de clientes VIP'];
const PAYMENT_POINTS = [{
  icon: CreditCardIcon,
  label: 'Paga con Mercado Pago'
}, {
  icon: MailCheckIcon,
  label: 'Acceso inmediato vía mail'
}, {
  icon: UsersIcon,
  label: 'Comunidad de clientes VIP'
}];
export function OfferStack() {
  return <Section id="comprar" className="bg-ink-950" data-id="element-211" data-mp="2252al3h3zqfn">
      <div className="text-center" data-id="element-212" data-mp="2249dyvbv6hb8">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-accent-soft" data-id="element-213" data-mp="1efq78k8gqcl9">
          Todo lo que recibís hoy
        </p>
        <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-214" data-mp="19fvbo3dqsytv">
          Un pago único, todo el material y los 5 bonos incluidos
        </h2>
      </div>

      <div className="mt-10 overflow-hidden rounded-[2rem] border border-accent/25 bg-ink-900" data-id="element-215" data-mp="19n4waiszrowi">
        <div className="border-b border-white/8 px-6 py-5 text-center sm:px-9" data-id="element-216" data-mp="1efy116ogmx8l">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-white/40" data-id="element-217" data-mp="1jehlf2neo0yu">
            Diccionario Apple™ — Paquete completo
          </p>
          <p className="mt-2 text-xl font-extrabold tracking-tight text-white sm:text-2xl" data-id="element-218" data-mp="lsbx1xbblql7">
            Libro principal + 5 bonos de regalo
          </p>
        </div>

        <div className="grid gap-6 p-6 sm:p-9 lg:grid-cols-2" data-id="element-219" data-mp="vnlz2l1pxxyz">
          <div data-id="element-220" data-mp="zpqsbio98sl3">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-white/40" data-id="element-221" data-mp="zq8v6y5fa51z">
              Qué incluye
            </p>
            <ul className="mt-5 space-y-3" data-id="element-222" data-mp="2730sxfyms9pv">
              {INCLUDED.map(item => <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-white/75" data-id="element-223" data-mp="2b4e0pvlaamzf">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent/15" data-id="element-224" data-mp="bzcma0m8v6zl">
                    <CheckIcon className="h-3.5 w-3.5 text-accent-soft" aria-hidden="true" data-id="element-225" data-mp="70swfp4j5b1y" />
                  </span>
                  <span data-id="element-226" data-mp="kyznomez4csn">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border border-accent/30 bg-accent/[0.07] p-6 text-center sm:p-7" data-id="element-227" data-mp="g2sfemz3up7j">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-accent-soft" data-id="element-228" data-mp="3oi2h3tz31ses">
              Precio
            </p>
            <p className="mt-3 text-4xl font-extrabold tracking-tight text-white sm:text-5xl" data-id="element-229" data-mp="21y5fzwesg6r">
              $33.999 ARS
            </p>
            <p className="mt-3 text-xs font-semibold uppercase tracking-wide text-white/50" data-id="element-230" data-mp="3tfueh3ihy6qd">
              Pago único · Acceso de por vida
            </p>

            <div className="mt-6" data-id="element-231" data-mp="30s81j4ndppqu">
              <CTAButton className="items-center" note="Protegido por la garantía de devolución de 10 días." data-id="element-232" data-mp="30r6rn3i3n9ap" />
            </div>

            <ul className="mt-6 space-y-2 border-t border-white/10 pt-5 text-left" data-id="element-233" data-mp="1g8w6x6gyhb6w">
              {PAYMENT_POINTS.map(({
              icon: Icon,
              label
            }) => <li key={label} className="flex items-center gap-3 text-xs text-white/55 sm:text-sm" data-id="element-234" data-mp="17ak7qg20x52u">
                  <Icon className="h-4 w-4 shrink-0 text-accent-soft" aria-hidden="true" data-id="element-235" data-mp="1c9dnkf4s9866" />
                  {label}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </Section>;
}